import script from "./AddFilm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddFilm.vue?vue&type=script&setup=true&lang=ts"

import "./AddFilm.vue?vue&type=style&index=0&id=41095ecc&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41095ecc"]])

export default __exports__